export const customerQueryKeys = {
  dashboard: ["customer-dashboard-account"] as const,
  memberHome: ["customer-member-home"] as const,
  session: ["customer-session"] as const,
  order: ["customer-order"] as const,
  paymentMethodSetup: ["customer-payment-method-setup"] as const,
  purchase: (slug: string | null) => ["customer-purchase", slug] as const,
  purchaseSetup: (slug: string | null) => ["customer-purchase-setup", slug] as const,
  signupPage: (slug: string) => ["customer-signup-page", slug] as const,
  signupState: (signupId: string) => ["customer-signup-state", signupId] as const,
  tenant: ["customer-tenant"] as const,
}
